import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { patchImageSlider } from 'redux/image-sliders/actions';

import { Checkbox } from 'semantic-ui-react';

class ImageSliderPublishedCheckbox extends Component {
  static propTypes = {
    patchImageSlider: PropTypes.func.isRequired,
    isPublished: PropTypes.bool,
    sliderItem: PropTypes.object.isRequired,
  };

  static defaultProps = {
    isPublished: null,
  };

  state = {
    firstChange:  null,
    currentIsPublished: null,
  };

  componentDidMount() {
    this.setState({ currentIsPublished: this.props.isPublished });
  }

  componentDidUpdate(prevProps, prevState) {
    const { sliderItem, patchImageSlider } = this.props;
    const { currentIsPublished, firstChange } = this.state;

    if (
      !!firstChange &&
      prevState.currentIsPublished !== this.state.currentIsPublished
    ) {
      patchImageSlider(sliderItem.id, { is_published: currentIsPublished });
    }

    if (
      prevProps.sliderItem.media_items.length === 0 &&
      this.props.sliderItem.media_items.length > 0
    ) {
      patchImageSlider(sliderItem.id, { is_published: true });
    }

    if (
      prevProps.sliderItem.media_items.length > 0 &&
      this.props.sliderItem.media_items.length === 0
    ) {
      patchImageSlider(sliderItem.id, { is_published: false });
    }
  }

  onCheckboxChange = () => {
    this.setState({
      firstChange: true,
      currentIsPublished: !this.state.currentIsPublished,
    });
  };

  render() {
    const { sliderItem, isPublished } = this.props;
    const { firstChange, currentIsPublished } = this.state;

    return (
      <div className="image-slider-published-checkbox__component">
        <Checkbox
          toggle
          checked={firstChange ? currentIsPublished : isPublished}
          onChange={this.onCheckboxChange}
          disabled={sliderItem && sliderItem.media_items.length === 0}
        />
      </div>
    );
  }
}

export default connect(
  null,
  {
    patchImageSlider,
  },
)(ImageSliderPublishedCheckbox);
